import { Injectable } from '@angular/core';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { SortDirection } from '@angular/material/sort';
import { IAreaOfDevelopmentListResponse } from 'typings/api-activity';
import { AreaOfDevelopmentStore } from './area-of-development.store';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AreaOfDevelopmentService {
  constructor(private store: AreaOfDevelopmentStore, private $baseApi: DoenKidsGenericApiProvider) {}

  async fetchAll(limit: number = 100, skip: number = 0, sortField: string = 'created_at', sortDirection: SortDirection = 'desc') {
    const areaOfDevelopmentListResponse = await firstValueFrom(this.$baseApi.genericListCall('/activity/area-of-development', limit, skip, sortField, sortDirection)) as IAreaOfDevelopmentListResponse;

    this.store.set(areaOfDevelopmentListResponse?.items ?? []);
    return areaOfDevelopmentListResponse;
  }
}
